import axios from '../../plugins/axios'

export const listStore = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` }, params: payload ? payload.params : null }
  commit('SET_STORES', { stores: [] })
  return axios.get('/store', config)
    .then((response) => {
      commit('SET_STORES', { stores: response.data.stores })
      return response
    })
    .catch(err => err.response)
}

export const getStore = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  commit('SET_STORE', { store: null })
  return axios.get(`/store/${payload.id}`, config)
    .then((response) => {
      commit('SET_STORE', { store: response.data })
      return response
    })
    .catch(err => err.response)
}

export const createStore = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/store', payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const deleteStore = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.delete(`/store/${payload.id}`, config)
    .then(response => response)
    .catch(err => err.response)
}

export const updateStore = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.put(`/store/${payload.id}`, payload.data, config)
    .then(response => response)
    .catch(err => err.response)
}

export const createStoreAndUser = (_, payload) => {
  return axios.post('/store/register', payload.data)
    .then(response => response)
    .catch(err => err.response)
}

/**
 * spec 003: sube el logo de la etiqueta a Google Storage.
 *
 * Payload: { file: File, storeId?: number }
 * - Si el usuario es admin, debe incluir storeId.
 * - Si es store, storeId se ignora y se usa req.user.storeId del backend.
 *
 * Devuelve la promesa cruda con `data = { labelLogoUrl }`.
 */
export const uploadLabelLogo = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const form = new FormData()
  form.append('logo', payload.file)
  if (payload.storeId) form.append('storeId', String(payload.storeId))
  return axios.post('/store/label-settings/logo', form, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * spec 003: actualiza los custom fields de la etiqueta.
 *
 * Payload: { storeId, labelCustomField1, labelCustomField2 }
 * Devuelve la promesa cruda (response.data = store actualizado).
 */
export const updateLabelSettings = (_, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  const body = {
    labelCustomField1: payload.labelCustomField1,
    labelCustomField2: payload.labelCustomField2
  }
  return axios.put(`/store/${payload.storeId}/label-settings`, body, config)
}
